import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const fact = {
  fetchFact: lazyModuleMethod(() => import('./fetchFact'), 'default'),
  fetchFacts: lazyModuleMethod(() => import('./fetchFacts'), 'default'),
  createFact: lazyModuleMethod(() => import('./createFact'), 'default'),
  updateFact: lazyModuleMethod(() => import('./updateFact'), 'default'),
  deleteFact: lazyModuleMethod(() => import('./deleteFact'), 'default'),
  fetchFactGroups: lazyModuleMethod(
    () => import('./fetchFactGroups'),
    'default'
  ),
  createFactGroup: lazyModuleMethod(
    () => import('./createFactGroup'),
    'default'
  ),
  deleteFactGroup: lazyModuleMethod(
    () => import('./deleteFactGroup'),
    'default'
  ),
  updateFactGroup: lazyModuleMethod(
    () => import('./updateFactGroup'),
    'default'
  ),
}
